const Emoji_G = {
    ':geek': { id: 35, width: 20, height: 20 },
    ':gent': { id: 258, width: 15, height: 21 },
    ':george': { id: 259, width: 18, height: 18 },
    ':ghost1': { id: 261, width: 18, height: 21 },
    ':ghost2': { id: 262, width: 18, height: 21 },
    ':ghostface': { id: 263, width: 20, height: 28 },
    ':gigi': { id: 264, width: 15, height: 15 },
    ':glare': { id: 265, width: 20, height: 20 },
    ':good': { id: 266, width: 26, height: 23 },
    ':goss': { id: 267, width: 40, height: 20 },
    ':greedy': { id: 268, width: 18, height: 18 },
    ':grin': { id: 6, width: 18, height: 18 },
    ':gulp': { id: 271, width: 25, height: 17 },
    ':gun_guns': { id: 273, width: 48, height: 22 },
    ':gun_rifle': { id: 274, width: 49, height: 23 },
    ':gun2': { id: 272, width: 38, height: 18 },
}

export default Emoji_G
